import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import type KybWorkflow from '@banking/savings-onboarding-app/services/kyb-workflow';
import {
  backButtonClickAction,
  entityTypeScreenUpdateAction,
  userChangeEntityTypeAction,
} from '@banking/ui/workflows/onboarding-kyb/action';
import { action } from '@ember/object';
import { EntityTypeScreenData } from '@banking/ui/workflows/onboarding-kyb/state';
import { LegalEntitiesBusinessEntityType } from '@banking/api/utils/business-types';

export default class EntityType extends Controller {
  @service kybWorkflow!: KybWorkflow;

  entityTypesToExclude = [LegalEntitiesBusinessEntityType.NONPROFIT];

  @action submit(data: EntityTypeScreenData) {
    this.kybWorkflow.emit(entityTypeScreenUpdateAction(data));
  }

  @action goBack() {
    this.kybWorkflow.emit(backButtonClickAction());
  }

  @action onEntityTypeChange(entityType: LegalEntitiesBusinessEntityType) {
    this.kybWorkflow.emit(userChangeEntityTypeAction(entityType));
  }
}
